// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1mLSs","productName":"Table_productName__UMr4U"};